import { Fragment } from "react";

/** Escape a user query so it can be embedded literally in a RegExp (no accidental metacharacters). */
const escapeRegExp = (s: string): string => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/**
 * Renders `text` with every case-insensitive occurrence of `query` wrapped in a highlight chip — the search-match
 * marker (FN4b-2, the legacy "Suche"). Uses the client PRIMARY colour (red on takeda) with white ink, matching the
 * legacy highlighted term. `<mark>` is the semantic element for highlighted text (a11y). An empty/whitespace query, or
 * a query absent from the text, renders the text unchanged.
 *
 * A single capturing split keeps the delimiters, so the odd-indexed parts ARE the matches (case preserved).
 */
export function HighlightedText({ text, query, className }: { text: string; query: string; className?: string }) {
  const q = query.trim();
  if (!q) return <span className={className}>{text}</span>;
  const parts = text.split(new RegExp(`(${escapeRegExp(q)})`, "gi"));
  return (
    <span className={className}>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <mark key={i} className="bg-primary text-primary-foreground rounded-[3px] px-1 py-px">
            {part}
          </mark>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        ),
      )}
    </span>
  );
}
